import jwt from "jsonwebtoken";
import {
  APIKey,
  Authorization,
  Channel,
  DomainAPI,
  SecretApiKey,
  SecretApiKeyExpires,
} from "../utils/setting";

const plugin = {
  state: {
    listPlugin: [],
    // position: 0,
    // total: 0
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async getPlugin(payload, rootState) {
      if (payload) payload.sort = [["createdAt", "DESC"]];
      let url = DomainAPI + Channel + "/api/secure/plugins/getListPlugin";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          if (result.code === 1)
            this.setState({
              listPlugin: result.data,
            });
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async getOnePlugin(payload, rootState) {
      let url = DomainAPI + Channel + "/api/secure/plugins/getOnePlugin";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    // async insertplugin(payload, rootState) {
    //   const _this = this;
    //   let token = rootState.user.token;
    //   let url =
    //     DomainAPI +
    //     Channel +
    //     "/api/secure/plugin/insertplugin";
    //   let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
    //     expiresIn: SecretApiKeyExpires
    //   });
    //   let myHeaders = new Headers();
    //   myHeaders.append("Content-Type", "application/json");
    //   myHeaders.append(APIKey, key);
    //   myHeaders.append(Authorization, rootState.user.token);

    //   return fetch(url, {
    //     method: "POST",
    //     headers: myHeaders,
    //     body: JSON.stringify(payload)
    //   })
    //     .then(res => res.json())
    //     .then(result => {
    //       return result;
    //     })
    //     .catch(error => {
    //       return { code: 0, error: error, message: error.toString() };
    //     });
    // },
    // async updateplugin(payload = {}, rootState) {
    //   const _this = this;
    //   let token = rootState.user.token;
    //   let url =
    //     DomainAPI +
    //     Channel +
    //     "/api/secure/plugin/updateplugin";
    //   let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
    //     expiresIn: SecretApiKeyExpires
    //   });
    //   let myHeaders = new Headers();
    //   myHeaders.append("Content-Type", "application/json");
    //   myHeaders.append(APIKey, key);
    //   myHeaders.append(Authorization, rootState.user.token);

    //   return fetch(url, {
    //     method: "POST",
    //     headers: myHeaders,
    //     body: JSON.stringify(payload)
    //   })
    //     .then(res => res.json())
    //     .then(result => {
    //       return result;
    //     })
    //     .catch(error => {
    //       return { code: 0, error: error, message: error.toString() };
    //     });
    // },
    // async deleteplugin(payload = {}, rootState) {
    //   const _this = this;
    //   let token = rootState.user.token;
    //   let url =
    //     DomainAPI +
    //     Channel +
    //     "/api/secure/plugin/deleteplugin";
    //   let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
    //     expiresIn: SecretApiKeyExpires
    //   });
    //   let myHeaders = new Headers();
    //   myHeaders.append("Content-Type", "application/json");
    //   myHeaders.append(APIKey, key);
    //   myHeaders.append(Authorization, rootState.user.token);

    //   return fetch(url, {
    //     method: "POST",
    //     headers: myHeaders,
    //     body: JSON.stringify({ categoryIds: payload.categoryIds })
    //   })
    //     .then(res => res.json())
    //     .then(result => {
    //       //checkResponse(result, dispatch)
    //       // if(result.code) {
    //       //     dispatch.products.getListProduct(rootState)
    //       // }
    //       return result;
    //     })
    //     .catch(error => {
    //       return { code: 0, error: error, message: error.toString() };
    //     });
    // }
  }),
  // subscriptions: {
  //     'plugin/deleteMenuGroup': (action, state, unsubscribe) => {
  //         console.log("***********************subscriptions");
  //         dispatch.products.setState({})
  //         console.log(action);
  //         console.log(state);
  //     //   dispatch.settings.set(action.payload)
  //     }
  // }
};

export default plugin;
